import { JsConfig } from '@fcom/core';
import { isFlagEnabled } from '@fcom/core/utils/env.utils';

const apiBaseUrl = 'https://api.finnair.com';
const apiFullBaseUrl = `${apiBaseUrl}/d/fcom`;
const loyaltyApiBaseUrl = 'https://api.finnair.com/d/loyalty-service';
const feedbackCaseApiPublicUrl = `${apiBaseUrl}/d/customer-care-api/feedback-case-api/public`;

const isUpgradeBenefitsEffective = isFlagEnabled('2024-03-09T00:00:00.000+0300');
const isVisaLightCreditCardBannerEffective = isFlagEnabled('2024-12-12T00:00:00.000+0300');
const isKidsInBusinessNotificationEffective = isFlagEnabled('2025-05-20T09:00:00.000+0300');

const config: JsConfig = {
  /**
   * Map from lang to locale. E.g. { 'gb-en': 'en_GB' }
   */
  allowedLocales: {
    'master-en': 'en_GB',
    'at-de': 'de_AT',
    'at-en': 'en_AT',
    'au-en': 'en_AU',
    'be-en': 'en_BE',
    'ca-en': 'en_CA',
    'ca-fr': 'fr_CA',
    'ch-de': 'de_CH',
    'ch-en': 'en_CH',
    'ch-fr': 'fr_CH',
    'cn-en': 'en_CN',
    'cn-zh': 'zh_CN',
    'cz-en': 'en_CZ',
    'de-de': 'de_DE',
    'de-en': 'en_DE',
    'dk-da': 'da_DK',
    'dk-en': 'en_DK',
    'ee-en': 'en_EE',
    'ee-et': 'et_EE',
    en: 'en',
    'es-en': 'en_ES',
    'es-es': 'es_ES',
    'fi-en': 'en_FI',
    'fi-fi': 'fi_FI',
    'fi-sv': 'sv_FI',
    'fr-en': 'en_FR',
    'fr-fr': 'fr_FR',
    'gb-en': 'en_GB',
    'hk-zh': 'zh_HK',
    'hk-en': 'en_HK',
    'hu-en': 'en_HU',
    'is-en': 'en_IS',
    'ie-en': 'en_IE',
    'il-en': 'en_IL',
    'in-en': 'en_IN',
    'it-en': 'en_IT',
    'it-it': 'it_IT',
    'jp-en': 'en_JP',
    'jp-ja': 'ja_JP',
    'kr-en': 'en_KR',
    'kr-ko': 'ko_KR',
    'lt-en': 'en_LT',
    'lv-en': 'en_LV',
    'nl-en': 'en_NL',
    'no-en': 'en_NO',
    'no-no': 'no_NO',
    'pl-en': 'en_PL',
    'pl-pl': 'pl_PL',
    'ru-en': 'en_RU',
    'ru-ru': 'ru_RU',
    'se-en': 'en_SE',
    'se-sv': 'sv_SE',
    'sg-en': 'en_SG',
    'th-en': 'en_TH',
    'us-en': 'en_US',
  },
  apiBaseUrl,
  uxAuthBasePath: '/d/fcom/ux-auth-prod',
  baseUrl: 'https://www.finnair.com',
  buildEnv: 'prod',
  casAllowHttp: false,
  casClientId: 'I9AZwG5z3os',
  casClientIdDds: 'FFfOZx2as6M',
  casHost: 'auth.finnair.com',
  casEnv: 'prod',
  upgradeAvailabilityUrl: 'https://api.finnair.com/amadeus-upgrade-availability',
  checkoutUrl: 'https://pay.finnair.com',
  cmsUrl: 'https://cms.finnair.com',
  cmsEnv: 'prod',
  isCmsPreview: false,
  translationsApiUrl: `${apiFullBaseUrl}/ux-translation-prod/current`,
  cartUrl: `${apiFullBaseUrl}/cart-prod/current/api/v2/cart`,
  cartUrlWithoutAPI: `${apiFullBaseUrl}/cart-prod/current`,
  configUrl: `${apiFullBaseUrl}/config-prod/current`,
  instantSearchUrl: `${apiFullBaseUrl}/instantsearch-prod/current`,
  giftCardApiKey: '5iUkA9Pwly7DYTAJ2eRe77nzWrdrEDI93MaT6GY7',
  giftCardConversionUrl: `${apiBaseUrl}/d/payments/gift-card/public/gift-cards/payout`,
  giftCardVerificationUrl: `${apiBaseUrl}/d/payments/gift-card/public/gift-cards`,
  googleMapsApiKey: 'AIzaSyDvTBJvICnNK-DI14X6M1hXF9SXB8Dfuec',
  sentryDsnServer:
    'https://bce7d6be750ade48c6bc76b73d5ed1c5:3ddaedd1938b4e97fd5226fc0f2ee2a9@o4507887724986368.ingest.de.sentry.io/4508097692893264',
  sentryDsn: 'https://bce7d6be750ade48c6bc76b73d5ed1c5@o4507887724986368.ingest.de.sentry.io/4508097692893264',
  sentryEnv: 'prod',
  sentryPrefix: 'lambda-',
  versionInfo: {
    releaseGitCommitHash: 'unkown-commit-hash',
    releaseGitTag: 'unkown-git-tag',
  },
  locationRouteCffUrl: `${apiFullBaseUrl}/locations-prod/current`,
  placesServiceUrl: `${apiFullBaseUrl}/locations-prod/current/places`,
  timeGeoUrl: 'https://api.finnair.com/timegeo',
  orderUrl: `${apiFullBaseUrl}/order-prod/current`,
  eTicketReceiptsUrl: `${apiFullBaseUrl}/order-prod/current`,
  offersUrl: `${apiFullBaseUrl}/offers-prod/current`,
  tierBenefitUrl: `${apiFullBaseUrl}/benefits-prod/current/v2/tierBenefits`,
  oneUpgradeRootUrl: 'https://api.finnair.com/d/business-upgrade/bookings',
  upgradeApiGwKey: 'WknUloDLslm39Xtd2EbjWctxRUHpdc',
  showMarketingOffers: true,
  pnrSummaryInMMBWidget: true,
  servicesUrl: `${apiFullBaseUrl}/ancillary-prod/current`,
  checkInPostUrl: 'https://checkin.si.amadeus.net/1ASIHSSCWEBAY/sscway/checkindirect',
  cookieSnippetUrl: 'https://privacy.finnair.com/snippet.js?locale={locale}',
  consentApiUrl: 'https://api.finnair.com/d/consent-registry/consent-prod/current',
  forceWithCredentials: true,
  darkSiteForm: {
    incidentUpdates: {
      apiUrl: `${feedbackCaseApiPublicUrl}/darksite/incident-updates`,
      keyId: 'KuJoqqx3wX9O6ztCRYJX77rmBNXTRNWY3sF0Xaeg',
    },
  },
  serviceForm: {
    claimApi: {
      apiUrl: `https://api.finnair.com/d/customer-care-api/claim-api`,
      keyId: 'UzXjOg8J1C8ydHH3EUgAJ3RE5h4vswr64jTT8os1',
    },
    claimMissingAvios: {
      apiUrl: `${loyaltyApiBaseUrl}/legacy/current/api/claim`,
      keyId: 'Y6DcOC6tLW2IIKKUm2Ff5KLHNWd1Qd7386WGvVI0',
    },
    customerCare: {
      apiUrl: `${apiBaseUrl}/d/customer-care-api`,
      keyId: 'hEJnqZ0PWJ2W47zgpb1YC8JtkwhjDo8c27GEYCnQ',
    },
    customerCareAttachment: {
      apiUrl: `${apiBaseUrl}/d/customer-care-api/attachment/v1`,
      keyId: 'Z65C5iKKLL7okJRww5X4d5HOVRIRUeAA5Fnc4QsG',
    },
    customerFeedback: {
      apiUrl: feedbackCaseApiPublicUrl,
      keyId: 'KuJoqqx3wX9O6ztCRYJX77rmBNXTRNWY3sF0Xaeg',
      options: {
        lastNameQueryParam: 'lastName',
        attachmentPath: 'attachments',
        linkAttachmentPath: 'link-attachments',
      },
    },
    customerRefunds: {
      apiUrl: `${apiBaseUrl}/d/customer-care-api/refund-case/v1`,
      keyId: 'gMh8jRxonX47xTbxhT6blaZe2OWsFDNp9kU68Z1U',
    },
    eTicketReceipt: {
      apiUrl: 'https://api.finnair.com/a/booking-service/api/member/name/emailReceipt',
      keyId: '5mBIAH9Mpzaiu2zcHtN956rX0UYEv3hU8oP7BYb1',
    },
    loggedInMissingPoints: {
      apiUrl: `${loyaltyApiBaseUrl}/legacy/current/api/claim`,
      keyId: 'Y6DcOC6tLW2IIKKUm2Ff5KLHNWd1Qd7386WGvVI0',
    },
  },
  siteSearch: {
    siteSearchRequest: {
      apiUrl: 'https://finnair-app-search.ent.eu-central-1.aws.cloud.es.io/api/as/v1/engines/www-finnair-com-{lang}/',
      searchKey: 'search-dq8nn4v4fega72csth86bxch',
    },
  },
  carRental: {
    apiUrl: 'https://cars.finnair.com',
    clientId: '395702',
  },
  ondMarketingOffersUrl: `${apiFullBaseUrl}/destination-seo-prod/current`,
  agentforceChat: {
    disableLangRefresh: false,
    chatScriptSrcURL: 'https://finnair.my.site.com/ESWSISUforceAgentEN1736240220802/assets/js/bootstrap.min.js',
    scrt2URL: 'https://finnair.my.salesforce-scrt.com',
    queueConfigs: {
      deploymentId: '00D24000000Zb2l',
      buttonId: 'SISUforce_Agent_EN',
      agentUrl: 'https://finnair.my.site.com/ESWSISUforceAgentEN1736240220802',
    },
  },
  savedCardApiUrl: 'https://api.finnair.com/d/payments/prod--saved-card-api/public/saved-cards',
  savedCardApiKey: 'bprCgoMcQ62D46qHXHuu47kNCmGQiEVZ5166vSNn',
  membershipCardApiUrl: 'https://api.finnair.com/a/membershipcard',
  loyaltyServices: {
    memberService: {
      gauthUrl: `${loyaltyApiBaseUrl}/member-service/gauth`,
      gauthApiKey: '08Clo0m74Z8arPmCbTpyd8ravNu3N5xd3nBrYymZ',
    },
    legacy: {
      apiKey: '8SOdBCm2We2KVKumlsTaq6bfEC8QdbwO6sGybjEN',
      apiUrl: `${loyaltyApiBaseUrl}/legacy/current/api`,
      apiProfileUrl: `${loyaltyApiBaseUrl}/legacy/current/api/profile`,
      apiProfileApiKey: '5mBIAH9Mpzaiu2zcHtN956rX0UYEv3hU8oP7BYb1',
      loyaltyMemberUrl: `${loyaltyApiBaseUrl}/legacy/current/loyalty/member`,
      loyaltyMemberResendUrl: `${loyaltyApiBaseUrl}/legacy/current/loyalty/member/resend`,
      loyaltyMemberVerifyUrl: `${loyaltyApiBaseUrl}/legacy/current/loyalty/member/confirm`,
      loyaltyMemberApiKey: 'eb6b23a6-d3bd-4fcf-903d-c9be9763eab0',
      loyaltyAviosLinkingUrl: `${loyaltyApiBaseUrl}/legacy/current/api/avios/linked-accounts`,
      loyaltyProfileEmailChangeUrl: `${loyaltyApiBaseUrl}/legacy/current/loyalty/profile/email`,
      loyaltyProfileEmailVerifyUrl: `${loyaltyApiBaseUrl}/legacy/current/loyalty/profile/email/verify`,
      loyaltyProfileEmailConfirmUrl: `${loyaltyApiBaseUrl}/legacy/current/loyalty/profile/email/confirm`,
      loyaltyProfileMfaEmailEnable: `${loyaltyApiBaseUrl}/legacy/current/loyalty/profile/mfa/email/enable`,
    },
  },
  aviosLinkAndTransferUrl: 'https://www.avios.com/move/transfer-avios',
  bookingServiceUrl: 'https://api.finnair.com/a/booking-service/api',
  bookingServiceApiKey: '9114c782-00f5-4a99-b78a-68c6ce513ca3',
  destinationsSearchUrl: `${apiFullBaseUrl}/fcom-service-destinations-prod/destinations`,
  destinationsSearchApiKey: 'h4xl99cRYO5M7POBECCrO70M0NFc6Pb7Nl5y6lb3',
  amApiUrl: 'https://www.aurinkomatkat.fi/api/fcom-locations/v1',
  amFlightHotelDestinationUrl: 'https://www.aurinkomatkat.fi/api/fcom-fh-destinations',
  amDeeplinkUrl: 'https://www.aurinkomatkat.fi/matkahaku/finnair',
  buyPointsIframeUrl: 'https://ssogateway.points.com/SSOGateway/gateway.do',
  recommendationApiUrl: 'https://api.finnair.com/d/finnair-personalization/recommendation',
  reaccommodationTimeout: 15,
  corporateApiUrl: `${apiBaseUrl}/d/customer/corporate-rest-api-v2/current`,
  corporateApiKey: 'nhDJAHrHpx6S4JkRVEgvz4ck1mKLC9SL9kDaenBy',
  customerCommunicationsApiUrl: 'https://api.finnair.com/d/email-sender/customer-communications/current',
  storageRoot: 'finnaircom',
  appName: 'finnair-app',
  appIdIos: '933867978',
  manifestPathAndroid: 'assets/mobile-app/manifest-android.json',
  mobileAppVerificationSuccessUrls: {
    finnair: 'finnair://verify',
    'finnair-beta': 'finnair-beta://verify',
  },
  enablePerformanceProfiler: false,
  enableAwsXRay: true,
  datadog: {
    enabled: false,
    applicationId: '9b3f3d35-ef3a-4a15-bb97-51267d18b328',
    clientToken: 'pubc04b94691a72b3ba9a6eafbe33c0d785',
    site: 'datadoghq.eu',
  },
  enableExtraAuth: false,
  enableMockDapi: false,
  enableNewCity2CitySEOPages: false,
  enableCorsCredentials: false,
  enableWelcomeBackMessage: true,
  enableGlobalBanner: true,
  enableReaccommodationMockData: false,
  enableUpgradeTravelClass: false,
  enableBuyPoints: false,
  enableDapiBackendSwitch: false,
  enableDevTools: false,
  enableDevToolPath: false,
  choooseUrl: 'https://finnair.chooose.today/{lang}',
  enableTicketTypeUpselling: false,
  enableQualtricsPageFeedback: true,
  enableNewsletterSignUpForm: true,
  enableUpgradeAvailabilityInBooking: true,
  enableUpgradeAvailabilityPremiumEconomyInBooking: true,
  enableCookiePolicy: true,
  enableLoginDialog: true,
  enableJoinDialog: true,
  finnairShopDonateUrl: 'https://finnairshop.com/{lang}/finnair-plus-awards-and-products/charity',
  enableUpgradeBenefitInUpgrade: isUpgradeBenefitsEffective,
  finnairShopUrl: 'https://finnairshop.com/{lang}',
  enableAviosOverhaul: {
    isAviosCuttoffDateEffective: '2024-03-09T00:00:00.000+0300',
  },
  enableAdditionalEmailInBookingFlow: false,
  enableRefetchOrder: false,
  disableTermsAndConditionCheckbox: true,
  enableTicketTypeCardChanges: true,
  travelReady: {
    gatewayBaseUrl: 'https://widget-api.safetravel.amadeus.com',
    gatewayClientId: 'x1ASrT2jbpxSx0nacYnCYpswFF9iHOQ5',
    gatewayClientSecret: 'gmLFbYfYQE7kbjas',
    assetBaseUrl: '/cdn/lambda/prod/browser/',
  },
  gtmContainerSrc: '//www.googletagmanager.com',
  gtmContainerId: 'GTM-5JS398',
  enableShowingSAF: false,
  enableBwThirdPartyAncillaries: true,
  enableBwCarRentalSearch: false,
  enableBwHotelSearch: false,
  enableSalesforceDataCloud: true,
  salesforceDataCloudScriptSrcURL:
    'https://cdn.c360a.salesforce.com/beacon/c360a/db5e18f4-83ad-4c55-81d1-9c17648c979c/scripts/c360a.min.js',
  corporatePredict: true,
  enableSafContributionCard: true,
  enableVisaLightCreditCardBanner: isVisaLightCreditCardBannerEffective,
  enableEditPaxDetailsOnReviewPage: true,
  enableGermanRailway: true,
  enableShowFlightNumbers: true,
  enableBestPriceNowTag: false,
  corporateChoooseUrl: 'https://finnair-for-business.portal.chooose.today',
  enableNewDownloadAttachmentFlow: true,
  enableSpecialUpsellCategory: false,
  enableTravelExtrasTierBenefitTag: false,
  enableKidsInBusinessNotification: isKidsInBusinessNotificationEffective,
  enableMMBHotelDeeplink: true,
  enableHotelsBookingWidget: true,
  isOmanEnabled: isFlagEnabled('2025-06-30T00:00:00.000+0300'),
  enableSalesforceDirectCorporateEnrollment: true,
  enablePriorityServices: true,
  enableHotelsMMB: true,
  enableHotelsAttachModule: true,
  expediaWhiteLabelSiteUrlTemplate: 'https://{lang}.hotels.finnair.com',
  isPersonalisedDestinationsEnabled: true,
  enableUpgradeBookingLink: true,
  enableNonEuroUpgrades: true,
  enableBundleUpsellCard: true,
  enableCorporateDataViewComparison: false,
  autocompleteDestinationFormEnabled: true,
  enableCaobCheckinSales: true,
  imagesApiUrl: `${apiFullBaseUrl}/ux-images-api-v2-prod/current`,
  enableShoppingCart: true,
  enableShoppingCartForTransfers: false,
  enableShoppingCartForNonFinnairFlights: false,
  enableComboSubFlow: false,
  enableOneClickTicketTypeUpsell: true,
  enableAncillaryHighlightedServices: false,
  enableFinnairHighlightedAncillaries: false,
  enableSplitCancellation: true,
  enableMobileAppVerificationRedirect: true,
  enableResidentCardVerifier: true,
  enableAllianzThirdPartyAncillary: true,
  allianzUrl: 'https://www.magroup-online.com/WL/FIN/FI/{lang}?affiliateCode={affiliateCode}',
  enableChangesToInvoluntaryFlow: true,
  enableMissedConnection: true,
  enableScheduleChangeCategory: false,
  allowNewBrandTheming: false,
  enableUpgradeBlockWithPricesInMMB: true,
  enableFinnairPlusSignupInBookingFlow: false,
  enablePartnerPlacements: true,
  enablePersonalizedCombo: isFlagEnabled('2026-09-08T09:00:00.000+0300'),
  enableAncillaryFrontendQuota: false,
  enableMmbRedirectAfterPurchase: false,
  enableUxFarefamilyTags: false,
};

export const environment = config;
